import hyRequest from '@/service';
import {
  IFeedingHandover,
  IFeedingPowerOn,
  IFeedingTotal,
  IFeedingTable,
  IFeedingRatio,
  IFeedingTrend
} from './type';

enum DashboardApi {
  getFeedingHandover = '/feed/changeShifts',
  getFeedingPowerOn = '/feed/feedClass',
  getFeedingTotal = '/feed/feedOrderReport',
  getFeedingTable = '/feed/feedReportTable',
  getFeedingRatio = '/feed/feedContrast',
  getFeedingTrend = '/feed/feedTrend'
}

// 获取交接班时间
export function getFeedingHandover() {
  return hyRequest.post<IFeedingHandover>({
    url: DashboardApi.getFeedingHandover
  });
}

// 获取开关机时间
export function getFeedingPowerOn() {
  return hyRequest.post<IFeedingPowerOn>({
    url: DashboardApi.getFeedingPowerOn
  });
}

// 获取图标版统计
export function getFeedingTotal(data: {
  startTime: string;
  endTime: string;
  type: number;
}) {
  return hyRequest.post<IFeedingTotal>({
    url: DashboardApi.getFeedingTotal,
    data
  });
}

// 获取表格统计
export function getFeedingTable(data: {
  startTime: string;
  endTime: string;
  type: number;
}) {
  return hyRequest.post<IFeedingTable>({
    url: DashboardApi.getFeedingTable,
    data
  });
}

// 获取各平台进料量对比
export function getFeedingRatio(data: {
  startTime: string;
  endTime: string;
  type: number;
}) {
  return hyRequest.post<IFeedingRatio>({
    url: DashboardApi.getFeedingRatio,
    data
  });
}

// 获取进料量趋势
export function getFeedingTrend(data: {
  startTime: string;
  endTime: string;
  type: number;
}) {
  return hyRequest.post<IFeedingTrend>({
    url: DashboardApi.getFeedingTrend,
    data
  });
}
